import React, { forwardRef } from 'react';
import 'external-svg-loader';
import list from './icon-list';
import { StyledIcon } from './styled';
import StyledSvgAccordion from './special/accordion-styled';
import { cleanSVGProps } from './utils/svg-cleaner';
const URL_PATH = 'https://inventwidgetstorage.z19.web.core.windows.net/icons/';
const SvgIcon = ({ pathtoicon, ...props }) => process.env.NODE_ENV === 'test' ? (React.createElement("svg", { ...cleanSVGProps(props) })) : (React.createElement("svg", { "data-src": `${URL_PATH}${pathtoicon}.svg`, ...cleanSVGProps(props) }));
/**
 * Icon component to display SVG icons.
 *
 * @component
 * @param {object} props - Component props
 * @param {string} props.name - Used to determine the path to the SVG icon.
 * @param {string} [props.size='medium'] - Size of the icon
 * @param {string} props.color - Color of the icon
 * @param {any} ref - Reference to the component
 * @returns {React.Element} The Icon component
 *
 * @example
 * // To use the Icon component
 * import Icon from '@invent/icon';
 *
 * <Icon name="accordion" size="large" color="blue" />
 */
const Icon = ({ name, size = 'medium', color, ...restProps }, ref) => {
    const pathtoicon = list[name];
    if (!pathtoicon)
        return null;
    let SvgIconComponent = SvgIcon;
    // Because SvgAccordion should rotate
    if (name === 'accordion') {
        SvgIconComponent = StyledSvgAccordion;
    }
    return (React.createElement(StyledIcon, { "data-testid": `icon-${name}`, ref: ref, as: SvgIconComponent, "$size": size, "$color": color, pathtoicon: pathtoicon, ...restProps }));
};
export default forwardRef(Icon);
